export default "__VITE_ASSET__Dps7EWnm__"